"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Web = require("./web");
exports.Web = Web;
var Common = require("./common");
exports.Common = Common;
var bizarre = {
    Web: Web,
    Common: Common
};
exports.default = bizarre;
